import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../context/userContext";
import PageHead from "../component/PageHead";
import PostForm from "../component/PostForm";
import { authHeaders, CATEGORIES } from "../constants";

const EditPost = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [description, setDescription] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);
  const token = currentUser?.token;
  const { id } = useParams();

  useEffect(() => {
    if (!token) navigate("/login");
  }, [token, navigate]);

  useEffect(() => {
    const getPost = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts/${id}`);
        setTitle(response.data.title);
        setDescription(response.data.description);
        if (CATEGORIES.includes(response.data.category)) setCategory(response.data.category);
      } catch (err) {
        console.log(err);
      }
    };
    getPost();
  }, [id]);

  const editPost = async (e) => {
    e.preventDefault();
    const postData = new FormData();
    postData.set("title", title);
    postData.set("category", category);
    postData.set("description", description);
    postData.set("thumbnail", thumbnail);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/posts/${id}`,
        postData,
        authHeaders(token)
      );
      if (response.status === 200) navigate(`/posts/${id}`);
    } catch (err) {
      setError(err.response?.data?.message || "Couldn't save your changes.");
    }
  };

  return (
    <div className="container editor-page">
      <PageHead num="E" label="Edit post" line1="Revise," line2="then ship it again." />
      <PostForm
        {...{ title, setTitle, category, setCategory, description, setDescription, thumbnail, setThumbnail, error }}
        onSubmit={editPost}
        onCancel={() => navigate(-1)}
        submitLabel="Save changes"
      />
    </div>
  );
};

export default EditPost;
